import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ClipboardIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13.333 3.333H15A1.667 1.667 0 0 1 16.667 5v11.666A1.667 1.667 0 0 1 15 18.333H5a1.667 1.667 0 0 1-1.667-1.667V5A1.667 1.667 0 0 1 5 3.333h1.667" />
        <path d="M12.5 1.667h-5a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h5c.46 0 .833-.373.833-.833V2.5a.833.833 0 0 0-.833-.833Z" />
      </g>
    </Icon>
  );
}
